module.exports = __webpack_public_path__ + "img/0Q3B1666_L_Foamcore.2d677e2a.jpg";